import { tl } from '../../i18n/t';
import type { InvoiceState } from './types';

// Pfade: /app/rechnungen (Firmenwahl), /app/rechnungen/<Firma>, eine Rechnung als Fenster (?rechnung=<id>)
export const rePath = (clientId?: string) => (clientId ? `/app/rechnungen/${clientId}` : '/app/rechnungen');

export const STATE_BADGE: Record<InvoiceState, { label: string; cls: string }> = {
  offen: { label: tl('offen'), cls: 'badge b-warn' },
  ueberfaellig: { label: tl('überfällig'), cls: 'badge b-bad' },
  bezahlt: { label: tl('bezahlt'), cls: 'badge b-ok' },
  zurueckgezogen: { label: tl('zurückgezogen'), cls: 'badge b-none' },
  storniert: { label: tl('storniert'), cls: 'badge b-none' },
  storno: { label: tl('Stornorechnung'), cls: 'badge b-none' },
};
